<template>
    <div class="form-section">
        <slot />
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
.form-section {
    margin-block: 0 px2rem(60);

    @include bp(medium1) {
        margin-block: 0 px2rem(80);
    }

    &:first-of-type {
        margin-block: px2rem(40) px2rem(60);

        @include bp(medium1) {
            margin-block: px2rem(40) px2rem(80);
        }
    }
}
</style>
